import { secondsSinceTelemetryTimestamp } from './telemetry-time';

export const MACHINE_STATES = ['Desligado', 'Login', 'Checklist', 'Bloqueada', 'Operando', 'Bloqueado Remoto', 'Atualizando', 'Manutenção'];

export function snapshotMachineState(heartbeat: any, referenceTime: Date): string {
  if (!heartbeat) return 'Sem dados';
  const age = secondsSinceTelemetryTimestamp(heartbeat.stamp, referenceTime);
  if (age === null || age < 0) return 'Sem dados';
  if (age > 15 * 60) return 'Desligado';
  return MACHINE_STATES[Number(heartbeat.state)] || 'Sem dados';
}

export function countSnapshotStates(equipment: any[], heartbeats: any[], referenceTime: Date): Record<string, number> {
  const counts: Record<string, number> = Object.fromEntries([...MACHINE_STATES, 'Sem dados'].map(state => [state, 0]));
  const byId = new Map(heartbeats.map(hb => [String(hb.id), hb]));
  equipment.forEach(eq => { counts[snapshotMachineState(byId.get(String(eq.id)), referenceTime)] += 1; });
  return counts;
}
